// extracted by mini-css-extract-plugin
module.exports = {"margin":"filter__margin__iDT++","filterBlock":"filter__filterBlock__qGWBd","isFilter":"filter__isFilter__VIMne","cleanButton":"filter__cleanButton__yjHeQ"};